module.exports = __webpack_public_path__ + "static/media/cash-in-hand.4c1588ad.png";